/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */

export function HeaderMenu({ layoutProps }) {
  return null;
}
